import { useState, useRef } from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { Modal } from "antd";
import Avatar from "react-avatar-edit";

const defaultAspectRatios = [
  { label: "Custom", value: null },
  { label: "16:9", value: 16 / 9 },
  { label: "5:4", value: 5 / 4 },
  { label: "1:1", value: 1 },
  { label: "5:2", value: 5 / 2 },
];

const ImageCrop = ({
  src: srcProp,
  aspectRatio,
  membershipCard,
  isAvatar,
  handleCropComplete,
  handleCancelImageCrop,
}) => {
  const [src] = useState(srcProp);
  const [crop, setCrop] = useState(
    membershipCard
      ? { unit: "%", width: 100, aspect: null, show: true }
      : { unit: "%", width: 100, aspect: aspectRatio, show: true }
  );
  const [aspectIndex, setAspectIndex] = useState(-1);

  const imageRef = useRef(null);
  const fileUrlRef = useRef(null);

  const onImageLoaded = (image) => {
    if (!isAvatar) {
      imageRef.current = image;
    } else {
      const img = document.createElement("img");
      img.src = image;
      imageRef.current = img;
    }
  };

  const getCroppedImg = (image, cropArea, fileName) => {
    let canvas, scaleX, scaleY, ctx;
    if (!isAvatar) {
      canvas = document.createElement("canvas");
      scaleX = image.naturalWidth / image.width;
      scaleY = image.naturalHeight / image.height;
      canvas.width = cropArea.width * scaleY * 2;
      canvas.height = cropArea.height * scaleY * 2;
      ctx = canvas.getContext("2d");
      ctx.fillStyle = "white";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(
        image,
        cropArea.x * scaleX,
        cropArea.y * scaleY,
        cropArea.width * scaleX,
        cropArea.height * scaleY,
        0,
        0,
        canvas.width,
        canvas.height
      );
    } else {
      canvas = document.createElement("canvas");
      canvas.width = image.width;
      canvas.height = image.height;
      ctx = canvas.getContext("2d");
      ctx.imageSmoothingQuality = "high";
      ctx.fillStyle = "white";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
    }

    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          console.error("Canvas is empty");
          return;
        }
        blob.name = fileName;
        window.URL.revokeObjectURL(fileUrlRef.current);
        fileUrlRef.current = window.URL.createObjectURL(blob);
        resolve(
          new File([blob], fileName, {
            type: blob.type,
            lastModified: Date.now(),
          })
        );
      }, "image/jpeg");
    });
  };

  const makeClientCrop = async (cropArea) => {
    const croppedImage = await getCroppedImg(
      imageRef.current,
      cropArea,
      "newFile.jpeg"
    );
    handleCropComplete(croppedImage);
  };

  const onCropComplete = () => {
    let activeCrop = crop;
    if (activeCrop.x === 0 && activeCrop.y === 0 && activeCrop.height === 0) {
      activeCrop = {
        aspect: null,
        x: 0,
        y: 0,
        unit: "px",
        width: imageRef.current.width,
        height: imageRef.current.height,
      };
    }
    makeClientCrop(activeCrop);
  };

  const onCropChange = (newCrop) => {
    setCrop((prev) =>
      prev.x === newCrop.x &&
      prev.y === newCrop.y &&
      prev.width === newCrop.width &&
      prev.height === newCrop.height &&
      prev.unit === newCrop.unit
        ? prev
        : newCrop
    );
  };

  return (
    <>
      <Modal open={true} onOk={onCropComplete} onCancel={handleCancelImageCrop}>
        <h5>Image Crop</h5>
        {!isAvatar ? (
          <ReactCrop
            key={aspectIndex}
            src={srcProp}
            crop={crop}
            onImageLoaded={onImageLoaded}
            onChange={onCropChange}
            imageStyle={{ background: "#ffffff" }}
          />
        ) : (
          <Avatar
            width={"auto"}
            height={350}
            onCrop={onImageLoaded}
            src={src}
            label="Click here to select an image"
          />
        )}

        <div className="d-flex" style={{ justifyContent: "space-between" }}>
          {!aspectRatio &&
            !membershipCard &&
            defaultAspectRatios.map((aspect, index) => (
              <button
                key={index}
                type="button"
                className={
                  index === aspectIndex
                    ? "btn btn-sm btn-info mt-3 mb-2"
                    : "btn btn-sm btn-outline-info mt-3 mb-2"
                }
                onClick={() => {
                  if (index !== aspectIndex) {
                    // Reset first, then apply new aspect ratio (two-pass to force remount)
                    setCrop({ unit: "%", width: 100, aspect: aspect.label, show: true });
                    setAspectIndex(-1);
                    setTimeout(() => {
                      setCrop({ unit: "%", width: 100, aspect: aspect.value, show: true });
                      setAspectIndex(index);
                    }, 0);
                  }
                }}
              >
                {aspect.label}
              </button>
            ))}
        </div>
      </Modal>
    </>
  );
};

export default ImageCrop;
